"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneConfig = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _oneCdnAdapter = require("@yy/one-cdn-adapter");

var _CDNUrlCreator = require("./CDNUrlCreator");

var config = _interopRequireWildcard(require("./config"));

var _utils = require("./utils");

var _ConfigError = require("./ConfigError");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var defaultPriority = ['s3', 'oss'];
var defualtEnv = 'product';
var debugApiPrefix = 'https://lms-dev.inshopline.com';

var OneConfig = /*#__PURE__*/function () {
  /**
   * create cdn path by key
   */
  function OneConfig(_ref) {
    var _this = this;

    var priority = _ref.priority,
        env = _ref.env,
        onError = _ref.onError,
        debugMode = _ref.debugMode;
    (0, _classCallCheck2["default"])(this, OneConfig);
    (0, _defineProperty2["default"])(this, "currentGetMethod", 'api');
    (0, _defineProperty2["default"])(this, "detectPromise", null);
    (0, _defineProperty2["default"])(this, "checkPathCrator", new _CDNUrlCreator.CDNUrlCreator('develop'));
    var finalPriority = priority || defaultPriority;
    this.onError = onError;
    this.env = this.handleEnv(env || defualtEnv);
    this.debugMode = debugMode || false;
    this.cdnPathCrator = new _CDNUrlCreator.CDNUrlCreator(this.env);
    this.avaliableMethods = [].concat((0, _toConsumableArray2["default"])(finalPriority), ['api']);
    this.cdnAdaptor = new _oneCdnAdapter.CdnAdaptor({
      cdnConfigs: config.cdnConfigs,
      toUrl: config.toUrl,
      priority: finalPriority,
      checkAlive: function checkAlive(_, cdnOptions) {
        return [cdnOptions.host, /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var path, res;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  path = "".concat(config.addProtocol(cdnOptions.host), "/").concat(_this.checkPathCrator.createPathByKey('aliveCheck'));
                  _context.next = 4;
                  return _axios["default"].get(path);

                case 4:
                  res = _context.sent;
                  return _context.abrupt("return", res.status === 200);

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](0);
                  return _context.abrupt("return", false);

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 8]]);
        }))];
      },
      onError: function onError(error) {
        var host = error.cdn.host;
        var method = config.getCdnByHost(error.cdn.host);

        _this.throwError(method, _ConfigError.errorMessageCreator.detect({
          host: host,
          method: method
        }));
      }
    });
    this.detectAvailableRequestMethod();
  }
  /**
   * 寻找可用的方法
   */


  (0, _createClass2["default"])(OneConfig, [{
    key: "detectAvailableRequestMethod",
    value: function () {
      var _detectAvailableRequestMethod = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.detectPromise) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", Promise.resolve(this.detectPromise));

              case 2:
                this.detectPromise = new Promise( /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve) {
                    var paths, _this2$cdnAdaptor, _ref4, _ref5, cdn, errors, requestMethod, inavaliableCdns;

                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            paths = Object.values(config.cdnConfigs).map(function (item) {
                              return "".concat(config.addProtocol(item.host), "/").concat(_this2.checkPathCrator.createPathByKey('aliveCheck'));
                            });
                            _context2.prev = 1;
                            _context2.next = 4;
                            return (_this2$cdnAdaptor = _this2.cdnAdaptor) === null || _this2$cdnAdaptor === void 0 ? void 0 : _this2$cdnAdaptor.getAvailableUrl(paths[0]);

                          case 4:
                            _context2.t0 = _context2.sent;

                            if (_context2.t0) {
                              _context2.next = 7;
                              break;
                            }

                            _context2.t0 = [];

                          case 7:
                            _ref4 = _context2.t0;
                            _ref5 = (0, _slicedToArray2["default"])(_ref4, 2);
                            cdn = _ref5[0];
                            errors = _ref5[1];
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            requestMethod = (0, _utils.detectCDN)(cdn); // 如果第一次校验就有源失败，则直接过滤

                            if (errors !== null && errors !== void 0 && errors.length) {
                              inavaliableCdns = errors.map(function (item) {
                                var _item$cdn;

                                return (0, _utils.detectCDN)(item === null || item === void 0 ? void 0 : (_item$cdn = item.cdn) === null || _item$cdn === void 0 ? void 0 : _item$cdn.host);
                              });
                              _this2.avaliableMethods = _this2.avaliableMethods.filter(function (cdn) {
                                return !(inavaliableCdns !== null && inavaliableCdns !== void 0 && inavaliableCdns.includes(cdn));
                              }).concat(['api']);
                            }

                            _this2.currentGetMethod = requestMethod;
                            resolve();
                            _context2.next = 22;
                            break;

                          case 17:
                            _context2.prev = 17;
                            _context2.t1 = _context2["catch"](1);
                            _this2.currentGetMethod = 'api';
                            _this2.avaliableMethods = ['api'];
                            resolve();

                          case 22:
                            _context2.prev = 22;
                            resolve();
                            _this2.detectPromise = null;
                            return _context2.finish(22);

                          case 26:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[1, 17, 22, 26]]);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function detectAvailableRequestMethod() {
        return _detectAvailableRequestMethod.apply(this, arguments);
      }

      return detectAvailableRequestMethod;
    }()
  }, {
    key: "createReuqestPath",
    value: function createReuqestPath(key) {
      var _this3 = this,
          _createFnPathMap$this;

      var path = this.cdnPathCrator.createPathByKey(key);
      var createFnPathMap = {
        s3: function s3() {
          return "".concat(config.addProtocol(config.cdnConfigs.s3.host), "/").concat(path);
        },
        oss: function oss() {
          return "".concat(config.addProtocol(config.cdnConfigs.oss.host), "/").concat(path);
        },
        api: function api() {
          return "".concat(_this3.debugMode ? debugApiPrefix : '', "/").concat(config.API_PREFIX, "/").concat(key);
        }
      };
      return (_createFnPathMap$this = createFnPathMap[this.currentGetMethod]) === null || _createFnPathMap$this === void 0 ? void 0 : _createFnPathMap$this.call(createFnPathMap);
    }
  }, {
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(key) {
        var _this4 = this;

        var path, currentMethod;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.resolve(this.detectPromise);

              case 2:
                path = this.createReuqestPath(key);
                currentMethod = this.currentGetMethod;
                return _context4.abrupt("return", _axios["default"].get(path).then(function (res) {
                  return _this4.responseHandler(currentMethod, res);
                })["catch"](function () {
                  return _this4.handleCatch(currentMethod, key);
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function get(_x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * 批量请求 keys
     */

  }, {
    key: "all",
    value: function () {
      var _all = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(keys) {
        var _this5 = this;

        var list;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (keys !== null && keys !== void 0 && keys.length) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", Promise.resolve([]));

              case 2:
                if (!(keys.length > 1)) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return Promise.resolve(this.detectAvailableRequestMethod());

              case 5:
                _context5.next = 7;
                return Promise.all(keys.map(function (key) {
                  return _this5.get(key);
                }));

              case 7:
                list = _context5.sent;
                return _context5.abrupt("return", keys.reduce(function (acc, key, index) {
                  acc[key] = list[index];
                  return acc;
                }, {}));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function all(_x3) {
        return _all.apply(this, arguments);
      }

      return all;
    }()
  }, {
    key: "throwError",
    value: function throwError(type, msg) {
      var _this$onError;

      var error = new _ConfigError.ConfigError({
        requestType: type,
        message: msg,
        env: this.env,
        type: msg !== null && msg !== void 0 && msg.includes('network error') ? 'warning' : 'error'
      });
      (_this$onError = this.onError) === null || _this$onError === void 0 ? void 0 : _this$onError.call(this, error);
      return error;
    }
    /**
    * currentMethod is the method which is used to get config but unavailable
    */

  }, {
    key: "backup",
    value: function backup(currentMethod) {
      if (!currentMethod) return;
      var existed = this.avaliableMethods.filter(function (item) {
        return item === currentMethod;
      }); // 如果当前的方法已经完成 backup，则不再处理

      if (!(existed !== null && existed !== void 0 && existed.length)) return; // 如果可用的配置还有最少2种，则可以进行 backup 操作

      if (this.avaliableMethods.length > 1) {
        this.avaliableMethods = this.avaliableMethods.slice(1);
        var nextMethod = this.avaliableMethods[0];
        this.currentGetMethod = nextMethod;
        this.throwError(currentMethod, _ConfigError.errorMessageCreator.failedToFetch({
          currentMethod: currentMethod,
          nextMethod: nextMethod
        }));
      }
    }
  }, {
    key: "handleCatch",
    value: function () {
      var _handleCatch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(currentMethod, key) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.detectOnline()) {
                  _context6.next = 2;
                  break;
                }

                throw this.throwError(currentMethod, _ConfigError.errorMessageCreator.newtowkFailed());

              case 2:
                if (!(currentMethod === 'api')) {
                  _context6.next = 4;
                  break;
                }

                throw this.throwError(currentMethod, _ConfigError.errorMessageCreator.failedToFetch({
                  currentMethod: currentMethod
                }));

              case 4:
                this.backup(currentMethod);
                return _context6.abrupt("return", this.get(key));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function handleCatch(_x4, _x5) {
        return _handleCatch.apply(this, arguments);
      }

      return handleCatch;
    }()
  }, {
    key: "responseHandler",
    value: function responseHandler(currentGetMethod, res) {
      if (currentGetMethod === 'api') {
        var _res$data, _res$data$data;

        return res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.config;
      } else {
        return res === null || res === void 0 ? void 0 : res.data;
      }
    }
  }, {
    key: "detectOnline",
    value: function detectOnline() {
      /** 非浏览器环境跳过检测 */
      if (!(0, _utils.isBrowser)()) {
        return true;
      } else {
        var _window, _window$navigator;

        return (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.onLine;
      }
    }
  }, {
    key: "handleEnv",
    value: function handleEnv(env) {
      if (env === 'dev') {
        return 'develop';
      }

      return env;
    }
  }]);
  return OneConfig;
}();

exports.OneConfig = OneConfig;